import { useQuery } from '@tanstack/react-query';
import { fetchIterationSummary } from './iterationSummary.service';
import useSettingsService from 'components/hooks/useSettingsService';
import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';

const useFetchSummaryData = ({ teamId, iterationProviderId }: any = {}) => {
  const { getSettingOrDefinitionValue } = useSettingsService();

  const isVisionInsightsEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.isVisionInsightsEnabled
  });

  const { data: response, isLoading } = useQuery({
    queryFn: () => fetchIterationSummary({ iterationProviderId, teamId }),
    queryKey: ['iterationSummary', teamId, iterationProviderId],
    enabled: !!teamId && !!iterationProviderId && isVisionInsightsEnabled,
    refetchOnWindowFocus: false
  });

  return { isLoading, data: response?.data, status: response?.status };
};

export default useFetchSummaryData;
